export function formatBookingTypeLabel(type) {
  if (type === "transfer") {
    return "Base Transfer";
  } else if (type === "experience") {
    return "Base Experience";
  }
  return "Base Service";
}

export function formatPrice(price) {
  return Number.parseFloat(price).toFixed(2);
}

export function calculateGrossProfit(grossPrice, netPrice) {
  return parseFloat((grossPrice - netPrice).toFixed(2));
}

export function calculateTotalCommissions(commissions = []) {
  return commissions.reduce((total, amount) => {
    return parseFloat((total + parseFloat(amount)).toFixed(2));
  }, 0);
}
